import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import BugReportModal from "./BugReportModal.jsx";

export default function HelpWidget() {
  const [open, setOpen] = useState(false);      // bug modal
  const [expanded, setExpanded] = useState(false); // corner widget expanded/collapsed
  const { user } = useAuth();
  const loc = useLocation();

  const visible =
    user &&
    ["/search", "/profile"].some((p) => loc.pathname.startsWith(p));

  if (!visible) return null;

  return (
    <>
      {expanded ? (
        // Expanded: show X + round FAB
        <div className="help-fab-wrap">
          <button
            type="button"
            className="help-fab-dismiss"
            onClick={() => setExpanded(false)}
            aria-label="Hide help widget"
            title="Hide help widget"
          >
            ×
          </button>

          <button
            className="help-fab"
            onClick={() => setOpen(true)}
            aria-label="Help and feedback"
            title="Help and feedback"
          >
            ?
          </button>
        </div>
      ) : (
        // Collapsed: tiny tab peeking from the corner
        <button
          type="button"
          className="help-tab"
          onClick={() => setExpanded(true)}
          aria-label="Open help widget"
          title="Help & feedback"
        >
          ?
        </button>
      )}

      <BugReportModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
